'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _validateUpgradeData = require('ui-addon-upgrades/_core/common/data/upgradeData/validateUpgradeData');

var _validateUpgradeData2 = _interopRequireDefault(_validateUpgradeData);

var _upgradeDataPropsInterface = require('ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface');

var _createUpgradeData = require('ui-addon-upgrades/_core/common/data/upgradeData/createUpgradeData');

var _meetingHelpers = require('ui-addon-upgrades/_core/common/api/meetingHelpers');

var _didUpgradeDataChange = require('ui-addon-upgrades/_core/common/data/upgradeData/didUpgradeDataChange');

var _didUpgradeDataChange2 = _interopRequireDefault(_didUpgradeDataChange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var connectUpgradeData = function connectUpgradeData(Component, upgradeSource) {
  var UpgradeDataHOC = function (_React$Component) {
    _inherits(UpgradeDataHOC, _React$Component);

    function UpgradeDataHOC(props) {
      _classCallCheck(this, UpgradeDataHOC);

      var _this = _possibleConstructorReturn(this, (UpgradeDataHOC.__proto__ || Object.getPrototypeOf(UpgradeDataHOC)).call(this, props));

      _this.state = {
        renderBlockingUpgradeData: {},
        lazyLoadedUpgradeData: {}
      };
      return _this;
    }

    _createClass(UpgradeDataHOC, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.mounted = true;

        var _props = this.props,
            upgradeData = _props.upgradeData,
            allowModal = _props.allowModal;


        if (allowModal) {
          (0, _meetingHelpers.prefetchMeetingData)();
        }

        if (!upgradeData || !upgradeSource) {
          return _q2.default.Promise.resolve();
        }

        return this.wrapUpgradeData();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        // Re-wrap upgrade data if the upgrade data has changed
        // Note that we dont gate this in shouldComponentUpdate because
        // we'd have to do checks for the state changing as well which might
        // get a bit messy
        if ((0, _didUpgradeDataChange2.default)(prevProps.upgradeData, this.props.upgradeData)) {
          this.wrapUpgradeData();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: 'wrapUpgradeData',
      value: function wrapUpgradeData() {
        var _this2 = this;

        var upgradeData = this.props.upgradeData;


        return (0, _createUpgradeData.createRenderBlockingUpgradeData)(upgradeData, upgradeSource, this.props).then(function (renderBlockingUpgradeData) {
          // Since this is in a promise handler, it's possible the component has unmounted in that time
          // Will cause a warning if we setState on the unmounted component
          // See: https://github.com/facebook/react/issues/3417
          if (_this2.mounted) {
            _this2.setState({ renderBlockingUpgradeData: renderBlockingUpgradeData });
          }

          return renderBlockingUpgradeData;
        }).then(function (renderBlockingUpgradeData) {
          return (0, _createUpgradeData.createLazyLoadedUpgradeData)(renderBlockingUpgradeData, upgradeSource, _this2.props).then(function (lazyLoadedUpgradeData) {
            if (_this2.mounted) {
              _this2.setState({ lazyLoadedUpgradeData: lazyLoadedUpgradeData });
            }

            return lazyLoadedUpgradeData;
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            renderBlockingUpgradeData = _state.renderBlockingUpgradeData,
            lazyLoadedUpgradeData = _state.lazyLoadedUpgradeData;


        if (!(0, _underscore.isEmpty)(renderBlockingUpgradeData)) {
          var isValid = (0, _validateUpgradeData2.default)(renderBlockingUpgradeData);
          var newProps = _extends({}, this.props, {
            upgradeData: _extends({}, renderBlockingUpgradeData, lazyLoadedUpgradeData)
          });

          if (!isValid) {
            return null;
          }

          return _react2.default.createElement(Component, newProps);
        }

        return null;
      }
    }]);

    return UpgradeDataHOC;
  }(_react2.default.Component);

  UpgradeDataHOC.defaultProps = {
    allowModal: true
  };

  // mostly for decorators like promptable that complain
  var requiredComponentPropTypes = Component.propTypes ? (0, _underscore.pick)(Component.propTypes, ['onConfirm', 'onReject']) : {};

  UpgradeDataHOC.propTypes = _extends({}, requiredComponentPropTypes, _upgradeDataPropsInterface.upgradePropsInterface);

  return UpgradeDataHOC;
};

exports.default = connectUpgradeData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/connectUpgradeData.js
// module id = 188
// module chunks = 3 4 5